import {
  MediaGalleryItems,
  Product
} from '@features/product/components/Collection/Collection.types';
import { GalleryItem, Product as GlobalProduct, ProductImage } from '@features/product/typings';

export const getCollectionProductImageId = (product: GlobalProduct | Product | null): string => {
  if (!product?.mediaGallery?.items) return '';

  return (
    findImageIdByLabel('product color detail', product.mediaGallery.items) ||
    findImageIdByLabel('Main Image', product.mediaGallery.items) ||
    ''
  );
};

export const findImageIdByLabel = (
  label: string,
  items: GalleryItem[] | MediaGalleryItems[]
): string | undefined =>
  items.find((item): item is ProductImage => 'label' in item && item.label === label)?.image.id;
